function divideRgbBy255(rgbNumbers) {
  return rgbNumbers.map((number) => {
    let divideNumber = number / 255;
    return Math.round(divideNumber * 100) / 100;
  });
}

export default divideRgbBy255;
